export const DefaultSettings = {
    locationSettings: {
        address: 'London, UK',
        timeZoneID: 'Europe/London',
        lat: '51.5074',
        lng: '-0.1278'
    } /* صلى الله عليه وعلى آله وسلم */,
  calculationSettings: { method: "ISNA", asrMethod: "S" },
  deviceSettings: { azanCallsEnabled: "Y", mode: "N" },
  azanSettings: { fajr: "13", dhuhr: "7", asr: "9", maghrib: "6", isha: "3" },
  offsetSettings: { fajr: 0, dhuhr: 0, asr: 0, maghrib: 0, isha: 0 },
  alarmSettings: [],
  naflAlarmSettings: [],
  settingsVersion: 12,
};
